import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../endpoints'

export async function getLocations( queryString = ''){  
    let results = ''
    try {
        results = await axios.get(`${REACT_APP_API_ABM_FW}/abms/location${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}